
<div class="dialog-component">
  <div class="cross">
    <button
      id="dob-edit-close"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.closeDobDialog()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="dob-edit-close-mobile"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.closeDobDialog()"
      ></button>
    </div>


    <div class="edit-dob-body">
      @if (dialogData.dobError) {
        <div role="alert" aria-label="error" class="page-error">
          <label>Please enter a valid date of birth</label>
        </div>
      }
      <label class="dob-label" tabindex="0">
        Date of birth
      </label>
      <div [formGroup]="dialogData.dobForm" class="dob-input">
            <ng-container [ngTemplateOutlet]="dateofbirth" [ngTemplateOutletContext]="{ $implicit:'day',
             control: dialogData.dobForm.get('day'), displayType: 'dd', data: dialogData.days }">
        </ng-container>
            <ng-container [ngTemplateOutlet]="dateofbirth" [ngTemplateOutletContext]="{ $implicit:'month',
             control: dialogData.dobForm.get('month'), displayType: 'month', data: dialogData.months }">
        </ng-container>
            <ng-container [ngTemplateOutlet]="dateofbirth" [ngTemplateOutletContext]="{ $implicit:'year',
            control: dialogData.dobForm.get('year'), displayType: 'yyyy', data: dialogData.years }">
        </ng-container>
      </div>
      <div class="btn-container">
        <button tabindex="0" role="button" aria-label="save" class="send-button"
        [disabled]="" (click)="dialogData.editDateOfBirth()">Save</button>
      </div>
    </div>

  </div>
</div>

<!-- template for day, month, year select controls-->
<ng-template #dateofbirth let-dobType let-control="control" let-displayType="displayType" let-data="data">
  <select aria-label="date" [formControl]="control" [id]="dobType" (click)="dialogData.onDateInput()" >
    <option [value]="">{{displayType}}</option>
    @for (d of data; track d; let i = $index) {
      <option [value]="(dobType==='month') ? i+1 : d">
        {{d}}
      </option>
    }
  </select>
</ng-template>

